import _regeneratorRuntime from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/online-k8s-web-product-cloudv2@2/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, isRef as _isRef, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-f9c14dc4"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "in-info"
};
var _hoisted_2 = {
  key: 0,
  class: "bftips"
};
var _hoisted_3 = {
  key: 0,
  class: "operation"
};
var _hoisted_4 = {
  key: 1,
  class: "confirm"
};
import Info from '@/api/info';
import { useLang } from '@/hooks/lang';
import { XlButton, XlCascader, XlInput, XlMessage } from '@shining3d/ui-components';
import { $rdoLang } from '@/assets/common/common.js';
import { VueCookieNext } from 'vue-cookie-next';
import { useStore } from 'vuex';
// 向上回传数据

export default {
  props: {
    // 行业信息，接口获取或根据设备信息获取
    info: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // 是否是Odm Oem齿科客户端软件
    isOdmClient: {
      type: Boolean,
      default: false
    },
    // 是否是Odm Oem齿科客户端软件
    zIndex: {
      type: Number,
      default: 0
    },
    // 是否来自打印机软件端
    isSoftwareSide: {
      type: Boolean,
      default: false
    },
    // 来自哪个页面，用于区分按钮逻辑
    from: {
      type: String,
      default: 'dentalscan'
    }
  },
  emits: ['supply'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var props = __props;
    var _useLang = useLang(),
      $t = _useLang.$t;
    var store = useStore();
    var formRef = ref(null);
    var infoState = reactive(props.info);
    var orginInfoState = reactive(Object.assign({}, props.info));
    // const orginInfo = Object.assign({}, props.info );
    // const infoState = reactive( toRef( props, 'info' ));
    var industry = ref([]);
    var cascaderProps = {
      multiple: true
    };
    var clang = VueCookieNext.getCookie('lang');
    var industryContainsOther = ref(false);
    var industryContainsDental = ref(false); // 行业应用是否包含齿科
    var softwares = ref([]);
    var softwaresContainsOther = ref(false);
    var organs = ref([]);
    var companyTypeContainsOther = ref(false);
    var showOperation = ref(false); // 是否展示保存按钮
    var productLine = ref(infoState.productLine);
    if (productLine.value === 'dental') {
      // 应服务端要求若服务端传递来的产品线为dental统一转为dentalscan
      productLine.value = 'dentalscan';
    }
    var rules = {
      companyName: [{
        required: true,
        message: $t('industryInfo.enterpriseNamePlaceholder'),
        trigger: 'blur'
      }],
      companyPurpose: [{
        type: 'array',
        required: true,
        message: $t('industryInfo.industryScenePlaceholder'),
        trigger: 'blur'
      }],
      otherCompanyPurpose: [{
        required: true,
        message: $t('industryInfo.supplementIndustrySceneAlertText'),
        trigger: 'blur'
      }],
      companyType: [{
        required: true,
        message: $t('industryInfo.tissueTypesPlaceholder'),
        trigger: 'blur'
      }],
      otherCompanyType: [{
        required: true,
        message: $t('industryInfo.supplementTissueTypeText'),
        trigger: 'blur'
      }],
      software: [{
        type: 'array',
        required: true,
        message: $t('industryInfo.DataProcessingSoftwarePlaceholder'),
        trigger: 'blur'
      }],
      otherSoftware: [{
        required: true,
        message: $t('industryInfo.supplementSoftwarePlaceholder'),
        trigger: 'blur'
      }]
    };
    // 当产品线为齿科产品时，默认行业用途为齿科
    if (productLine.value === 'dentalscan') {
      industryContainsDental.value = true;
    }

    // 获取行业应用展示的值
    var companyPurpose = computed(function () {
      // 判断当选择了齿科相关行业应用时，展示组织类型的选择框
      industryContainsDental.value = false;
      if (infoState.companyPurpose && infoState.companyPurpose[0]) {
        var purp = infoState.companyPurpose[0].split('/');
        if (purp && purp[0] && purp[0] === 'dentalscan') {
          industryContainsDental.value = true;
        }
        if (productLine.value === 'dentalscan') {
          industryContainsDental.value = true;
        }
      }
      return getCascaderDisplayValue(infoState.companyPurpose, industryContainsOther);
    });

    // 计算数据处理软件展示文字
    var softwaresValue = computed(function () {
      return getCascaderDisplayValue(infoState.software, softwaresContainsOther);
    });

    // 计算组织类型展示文字
    var companyTypeValue = computed(function () {
      companyTypeContainsOther.value = findOrthers([infoState.companyType]);
      return infoState.companyType;
    });

    // 数据处理软件是否展示
    var dataProcessingSoftware = computed(function () {
      var show = false;
      // 仅非齿科行业时展示数据处理软件（及产品线为齿科不展示，行业用途为齿科应用时亦不展示）
      // if ( !( productLine.value === 'dentalscan' || productLine.value === 'dental' ) && !industryContainsDental.value ){
      // show = true;
      // }

      // 但产品线为3d数字化时，默认展示数据处理软件
      if (productLine.value === 'einScan' || productLine.value === 'einscan' || productLine.value === 'scan' || productLine.value === 'solidedge' || productLine.value === 'premium' || productLine.value === 'foundation' || productLine.value === 'classic' || productLine.value === 'academic') {
        show = true;
      }

      // 若不展示，则情况其中数据
      if (!show) {
        if (!infoState.software) {
          infoState.software = [];
        }
        if (!infoState.otherSoftware) {
          infoState.otherSoftware = '';
        }
      }
      return show;
    });
    var activateProductInformation = ref('');
    // 查询型号详细信息
    function queryModelDetailAPI() {
      return _queryModelDetailAPI.apply(this, arguments);
    }
    function _queryModelDetailAPI() {
      _queryModelDetailAPI = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, _res$result, res1, _res1$result;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return Info.queryModelDetailAPI({
                modelCode: infoState.modelCode,
                lang: $rdoLang(clang)
              });
            case 2:
              res = _context.sent;
              if (res.status === 'success') {
                activateProductInformation.value = ((_res$result = res.result) === null || _res$result === void 0 ? void 0 : _res$result.name) || '';
              }
              if (activateProductInformation.value) {
                _context.next = 9;
                break;
              }
              _context.next = 7;
              return Info.queryModelDetailAPI({
                modelCode: infoState.modelCode,
                lang: 'en'
              });
            case 7:
              res1 = _context.sent;
              if (res1.status === 'success') {
                activateProductInformation.value = ((_res1$result = res1.result) === null || _res1$result === void 0 ? void 0 : _res1$result.name) || '';
              }
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _queryModelDetailAPI.apply(this, arguments);
    }
    queryModelDetailAPI();

    // 获取级联组件用于展示的值（传入后端返回的value）
    function getCascaderDisplayValue(val, containsOther) {
      if (!val) {
        return [];
      }
      var arr = [];
      // TODO:换成Map处理
      val.forEach(function (element) {
        var a = element.split('/');
        arr.push(a);
      });
      containsOther.value = findOrthers(arr);
      return arr;
    }
    watch(infoState, function (newValue, oldVal) {
      // 当监听到表单内容发生变化时，则触发操作按钮展示
      showOperation.value = true;
    });

    // 取消编辑
    function cancelOperation() {
      showOperation.value = false;
      console.log('当前数据 ', infoState);
      console.log('原数据 ', orginInfoState);
      Object.keys(infoState).forEach(function (key) {
        infoState[key] = orginInfoState[key];
      });
      console.log('取消编辑，数据恢复为默认数据 = ', infoState);
    }
    // 修改并保存数据
    function changeCurrentInfo() {
      console.log('parameter == ', infoState);
      formRef.value.validate(function (valid, fields) {
        console.log('校验信息 == ', valid, fields);
        if (valid) {
          Info.updateCompanyInfo(infoState).then(function (res) {
            showOperation.value = false; // 隐藏操作按钮
            Object.keys(infoState).forEach(function (key) {
              orginInfoState[key] = infoState[key];
            });
            XlMessage({
              type: 'success',
              message: $t('messages.successEdit')
            });
          });
        }
      });
    }

    // 向外抛出表单数据
    function supply() {
      console.log('companyType == ', infoState);
      formRef.value.validate(function (valid, fields) {
        if (valid) {
          emit('supply', infoState);
        }
      });
    }

    // 转换级联组件内容为上送数据格式
    function conversionCascaderToUpJson(value) {
      return value.map(function (u) {
        return u.join('/');
      });
    }

    // 寻找是否数组末级是否存在others
    function findOrthers(value) {
      var isExist = false;
      value.forEach(function (u) {
        if (!isExist.value) {
          var lastObj;
          if (typeof u === 'string') {
            lastObj = u;
          } else {
            lastObj = u[u.length - 1];
          }
          if (lastObj === 'others') {
            isExist = true;
          }
        }
      });
      return isExist;
    }

    // 行业应用值发生变化
    function industryChange(value) {
      infoState.companyPurpose = conversionCascaderToUpJson(value);
    }

    // 数据处理软件值发生变化
    function dataProcessingSoftwareChange(value) {
      infoState.software = conversionCascaderToUpJson(value);
    }

    // 组织类型值发生变化
    function companyTypeChange(value) {
      console.log('组织类型 == ', value);
      if (!value) {
        infoState.companyType = '';
      } else if (value[0]) {
        infoState.companyType = value[0];
      }
    }

    // 转换行业信息适配el级联组件
    function conversionIndustryInfo(data, lg) {
      if (data.childs) {
        var arr = [];
        arr = data.childs.map(function (m) {
          return conversionIndustryInfo(m, lg);
        });
        data.children = arr;
      }
      var cc = 'en';
      if (lg === 'zh-cn') {
        cc = 'cn';
      } else if (lg === 'ja-jp') {
        cc = 'jap';
      }
      data.label = data.text[cc] || data.text.en;
      return data;
    }
    loadIndustry();
    loadOrgans();
    loadSoftwares();

    // 获取行业应用
    function loadIndustry() {
      if (store.state.industry) {
        industry.value = store.state.industry;
        return;
      }
      Info.getIndustrySourceInfo('passport_industry_uses').then(function (res) {
        var industryArray = [];
        var defaultArray = [];
        res.result && res.result.forEach(function (pinfo) {
          if (pinfo.keyName === productLine.value) {
            industryArray = JSON.parse(pinfo.other);
          }
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (industryArray.length <= 0) {
          industryArray = defaultArray;
        }
        industry.value = industryArray.map(function (item) {
          return conversionIndustryInfo(item, clang);
        });
        store.state.industry = industry.value;
        console.log('store.state.industry == ', store.state.industry);
      });
    }

    // 获取组织类型
    function loadOrgans() {
      if (store.state.organs) {
        organs.value = store.state.organs;
        return;
      }
      Info.getIndustrySourceInfo('passport_dental_factory_type').then(function (res) {
        var orginArray = [];
        var defaultArray = [];
        res.result && res.result.forEach(function (pinfo) {
          if (productLine.value === 'dentalscan') {
            /* 
            当产品线为齿科（dentalscan）时，会有多个dentalscan的keyname,
            此时需要找到keyValue为default的那一个
            */
            if (pinfo.keyName === productLine.value && pinfo.keyValue === 'default') {
              orginArray = JSON.parse(pinfo.other);
            }
          } else if (pinfo.keyName === productLine.value) {
            // 非dentalscan时则直接比对keyName与productLine一致即可
            orginArray = JSON.parse(pinfo.other);
          }

          // 保存default下的数据，作为未配置时的兜底数据
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (orginArray.length <= 0) {
          orginArray = defaultArray;
        }
        organs.value = orginArray.map(function (item) {
          return conversionIndustryInfo(item, clang);
        });
        store.state.organs = organs.value;
      });
    }

    // 获取数据处理软件
    function loadSoftwares() {
      if (store.state.softwares) {
        softwares.value = store.state.softwares;
        return;
      }
      Info.getIndustrySourceInfo('passport_product_soft').then(function (res) {
        var softwareArray = [];
        var defaultArray = [];
        res.result && res.result.forEach(function (pinfo) {
          if (pinfo.keyName === productLine.value) {
            softwareArray = JSON.parse(pinfo.other);
          }
          if (pinfo.keyName === 'default') {
            defaultArray = JSON.parse(pinfo.other);
          }
        });
        if (softwareArray.length <= 0) {
          softwareArray = defaultArray;
        }
        softwares.value = softwareArray.map(function (item) {
          return conversionIndustryInfo(item, clang);
        });
        store.state.softwares = softwares.value;
      });
    }
    return function (_ctx, _cache) {
      var _component_el_form_item = _resolveComponent("el-form-item");
      var _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        model: _unref(infoState),
        "label-width": "120px",
        rules: rules,
        "inline-message": "",
        class: "industries-form",
        "label-position": "top"
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_el_form_item, {
            label: _unref($t)('industryInfo.enterpriseNameText'),
            prop: "companyName"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).companyName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(infoState).companyName = $event;
                }),
                placeholder: _unref($t)('industryInfo.enterpriseNamePlaceholder')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"]), __props.isSoftwareSide || __props.isOdmClient ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref($t)("industryInfo.companyNameAuthenticityHint")), 1)) : _createCommentVNode("", true), !__props.isSoftwareSide && !__props.isOdmClient ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: _unref($t)('industryInfo.productInfoText')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: activateProductInformation.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return activateProductInformation.value = $event;
                }),
                disabled: "",
                placeholder: "--"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), _createVNode(_component_el_form_item, {
            prop: "companyPurpose",
            label: _unref($t)('industryInfo.industrySceneText')
          }, {
            default: _withCtx(function () {
              return [productLine.value !== 'dentalscan' ? (_openBlock(), _createBlock(_unref(XlCascader), {
                key: 0,
                style: _normalizeStyle([{
                  "width": "100%"
                }, {
                  'z-index': __props.zIndex === _unref(infoState).index ? 2000 : 19
                }]),
                modelValue: _unref(companyPurpose),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
                  return _isRef(companyPurpose) ? companyPurpose.value = $event : null;
                }),
                onChange: industryChange,
                onVisibleChange: _cache[3] || (_cache[3] = function ($event) {
                  return _ctx.$emit('changeZindex', _unref(infoState).index);
                }),
                options: industry.value,
                multiple: true,
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                clearable: "",
                transfer: "",
                mixedMultiple: "",
                placeholder: _unref($t)('industryInfo.industryScenePlaceholder'),
                width: "100%"
              }, null, 8, ["modelValue", "style", "options", "placeholder"])) : (_openBlock(), _createBlock(_unref(XlCascader), {
                key: 1,
                onChange: industryChange,
                style: {
                  "width": "100%"
                },
                modelValue: _unref(companyPurpose),
                "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
                  return _isRef(companyPurpose) ? companyPurpose.value = $event : null;
                }),
                options: industry.value,
                props: cascaderProps,
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                clearable: "",
                transfer: "",
                placeholder: _unref($t)('industryInfo.industryScenePlaceholder'),
                width: "100%"
              }, null, 8, ["modelValue", "options", "placeholder"]))];
            }),
            _: 1
          }, 8, ["label"]), industryContainsOther.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 2,
            prop: "otherCompanyPurpose"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).otherCompanyPurpose,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
                  return _unref(infoState).otherCompanyPurpose = $event;
                }),
                rows: 2,
                type: "textarea",
                placeholder: _unref($t)('industryInfo.supplementIndustrySceneAlertText')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), industryContainsDental.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 3,
            prop: "companyType",
            label: _unref($t)('industryInfo.tissueTypesText')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlCascader), {
                onChange: companyTypeChange,
                modelValue: _unref(companyTypeValue),
                "onUpdate:modelValue": _cache[6] || (_cache[6] = function ($event) {
                  return _isRef(companyTypeValue) ? companyTypeValue.value = $event : null;
                }),
                style: {
                  "width": "100%"
                },
                options: organs.value,
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                clearable: "",
                transfer: "",
                placeholder: _unref($t)('industryInfo.tissueTypesPlaceholder'),
                width: "100%"
              }, null, 8, ["modelValue", "options", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), industryContainsDental.value && companyTypeContainsOther.value ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 4,
            prop: "otherCompanyType"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).otherCompanyType,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) {
                  return _unref(infoState).otherCompanyType = $event;
                }),
                rows: 2,
                type: "textarea",
                placeholder: _unref($t)('industryInfo.supplementTissueTypeText')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), _unref(dataProcessingSoftware) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 5,
            prop: "software",
            label: _unref($t)('industryInfo.DataProcessingSoftwareText')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlCascader), {
                onChange: dataProcessingSoftwareChange,
                style: _normalizeStyle([{
                  "width": "100%"
                }, {
                  'z-index': __props.zIndex === _unref(infoState).index ? 1999 : 9
                }]),
                onVisibleChange: _cache[8] || (_cache[8] = function ($event) {
                  return _ctx.$emit('changeZindex', _unref(infoState).index);
                }),
                modelValue: _unref(softwaresValue),
                "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) {
                  return _isRef(softwaresValue) ? softwaresValue.value = $event : null;
                }),
                options: softwares.value,
                props: cascaderProps,
                "collapse-tags": "",
                "collapse-tags-tooltip": "",
                clearable: "",
                transfer: "",
                placeholder: _unref($t)('industryInfo.DataProcessingSoftwarePlaceholder'),
                width: "100%"
              }, null, 8, ["style", "modelValue", "options", "placeholder"])];
            }),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), softwaresContainsOther.value && _unref(dataProcessingSoftware) ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 6,
            prop: "otherSoftware"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).otherSoftware,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
                  return _unref(infoState).otherSoftware = $event;
                }),
                rows: 2,
                type: "textarea",
                placeholder: _unref($t)('industryInfo.supplementSoftwarePlaceholder')
              }, null, 8, ["modelValue", "placeholder"])];
            }),
            _: 1
          })) : _createCommentVNode("", true), !__props.isSoftwareSide && !__props.isOdmClient && productLine.value === 'solidedge' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 7,
            label: _unref($t)('offlineActive.deviceSn')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).deviceSN,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) {
                  return _unref(infoState).deviceSN = $event;
                }),
                disabled: "",
                placeholder: "--"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true), !__props.isSoftwareSide && !__props.isOdmClient && productLine.value === 'solidedge' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 8,
            label: _unref($t)('offlineActive.deviceModelCode')
          }, {
            default: _withCtx(function () {
              return [_createVNode(_unref(XlInput), {
                modelValue: _unref(infoState).deviceModelCode,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) {
                  return _unref(infoState).deviceModelCode = $event;
                }),
                disabled: "",
                placeholder: "--"
              }, null, 8, ["modelValue"])];
            }),
            _: 1
          }, 8, ["label"])) : _createCommentVNode("", true)];
        }),
        _: 1
      }, 8, ["model"]), showOperation.value && __props.from === 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_unref(XlButton), {
        onClick: cancelOperation
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)("button.cancel")), 1)];
        }),
        _: 1
      }), _createVNode(_unref(XlButton), {
        class: "pri-btn",
        type: "primary",
        onClick: changeCurrentInfo
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)("button.save")), 1)];
        }),
        _: 1
      })])) : _createCommentVNode("", true), __props.from === 'supplyuserinfo' ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_unref(XlButton), {
        class: "confirm-btn",
        type: "primary",
        onClick: supply
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_unref($t)("button.submit")), 1)];
        }),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
};